const VKEY = (id: string): string => `smm:draft-version:${id}`
const DEVICE_KEY = 'smm:device-id'

/** The project version this device last loaded/saved for a draft (for `if-match`). */
export function getLoadedVersion(id: string): number | undefined {
  const v = localStorage.getItem(VKEY(id))
  return v == null ? undefined : Number(v)
}

export function setLoadedVersion(id: string, version: number): void {
  localStorage.setItem(VKEY(id), String(version))
}

/** Stable per-browser id, stamped on saves as `x-device-id` for conflict notes. */
export function getDeviceId(): string {
  let d = localStorage.getItem(DEVICE_KEY)
  if (!d) {
    d = crypto.randomUUID()
    localStorage.setItem(DEVICE_KEY, d)
  }
  return d
}
